import th from '../../resources/locales/th-TH.json';
export default {
  ...th,
  ...JSON.parse(localStorage.getItem('overrides_translations') || '{}')['th-TH'],
};
